import { render, staticRenderFns } from "./select-post.vue?vue&type=template&id=3a66c3b2&scoped=true&"
import script from "./select-post.vue?vue&type=script&lang=js&"
export * from "./select-post.vue?vue&type=script&lang=js&"
import style0 from "./select-post.vue?vue&type=style&index=0&id=3a66c3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a66c3b2",
  null
  
)

export default component.exports